import { render, staticRenderFns } from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=template&id=c8b1f264&lang=pug&"
import script from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=script&lang=js&"
export * from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b1f264')) {
      api.createRecord('c8b1f264', component.options)
    } else {
      api.reload('c8b1f264', component.options)
    }
    module.hot.accept("./TableRowNumAudiogramsByAudiologist.vue?vue&type=template&id=c8b1f264&lang=pug&", function () {
      api.rerender('c8b1f264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/annually/TableRowNumAudiogramsByAudiologist.vue"
export default component.exports